import React from 'react';
interface TestimonialCardProps {
  initials: string;
  stars: number;
  quote: string;
  name: string;
  location: string;
  level: string;
}
function TestimonialCard({
  initials,
  stars,
  quote,
  name,
  location,
  level
}: TestimonialCardProps) {
  return <div className="bg-black border border-[#FF6B00]/30 rounded-2xl p-6 flex flex-col gap-4" data-id="element-272">
      <div className="flex items-center gap-3" data-id="element-273">
        <div className="w-12 h-12 rounded-full bg-[#FF6B00]/20 border border-[#FF6B00]/40 flex items-center justify-center text-[#FF6B00] font-black text-sm flex-shrink-0" data-id="element-274">
          {initials}
        </div>
        <div data-id="element-275">
          <div className="text-[#FF6B00] text-sm" data-id="element-276">{'⭐'.repeat(stars)}</div>
          <div className="text-white font-bold text-sm" data-id="element-277">{name}</div>
          <div className="text-gray-400 text-xs" data-id="element-278">
            📍 {location} | {level}
          </div>
        </div>
      </div>
      <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-279">"{quote}"</p>
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-280">
      <div className="max-w-5xl mx-auto" data-id="element-281">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-4" data-id="element-282">
          Lo que dicen los docentes de Inglés
          <br data-id="element-283" />
          <span className="text-[#FF6B00]" data-id="element-284">que ya tienen su PROFEPACK:</span>
        </h2>
        <p className="text-gray-400 text-center mb-10" data-id="element-285">
          +3.000 docentes de Argentina ya lo usan
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-286">
          <TestimonialCard initials="MG" stars={5} quote="Compré el PROFEPACK un domingo a la noche. El lunes tenía todo el año de Inglés de primaria organizado. Nunca pensé que un material iba a ser tan completo. Las secuencias didácticas son exactamente lo que necesitaba: no tengo que pensar de cero para cada clase. Y el solucionario es un lujo — corrijo en minutos." name="Mariela G." location="Córdoba" level="Docente de Inglés Primaria" data-id="element-287" />
          <TestimonialCard initials="CR" stars={5} quote="Empecé con Primaria y a los 3 días compré el Pack Completo. Doy clases en los dos niveles y no podía trabajar con la mitad del sistema. Lo que más me sorprendió fue que cada tomo tiene el solucionario integrado. Ya no pierdo tiempo corrigiendo — todo está ahí." name="Cecilia R." location="Mendoza" level="Docente de Inglés Primaria y Secundaria" data-id="element-288" />
          <TestimonialCard initials="RM" stars={5} quote="El Kit de Días Especiales me salvó la vida. Halloween y Christmas siempre eran mi peor pesadilla. Con PROFEPACK resolví cada fecha en 30 minutos con actividades, vocabulario y evaluación incluida. Mis colegas me preguntaron cómo lo había preparado tan bien." name="Roberto M." location="Buenos Aires" level="Docente de Inglés" data-id="element-289" />
          <TestimonialCard initials="FL" stars={5} quote="Lo que más valoro es que está organizado POR GRADO y alineado al currículo argentino. No tengo que adivinar qué le corresponde a cada año de primaria. Todo ya está pensado, ordenado y listo. Es como tener un colega experto que ya hizo todo el trabajo por mí." name="Fernando L." location="Tucumán" level="Docente de Inglés Primaria" data-id="element-290" />
          <TestimonialCard initials="LP" stars={5} quote="Como profe de secundaria lo que más me cambió fueron los tomos 3, 4 y 5. Mis alumnos de 3° y 4° año por fin enganchan con la clase porque el contenido los conecta con temas reales: medio ambiente, activismo, tecnología. Ya no tengo que pelearme con el celular." name="Laura P." location="Rosario" level="Docente de Inglés Secundaria" data-id="element-291" />
          <TestimonialCard initials="VT" stars={5} quote="Tengo grupos muy numerosos y poco tiempo. Las 30 Clases Salvavidas del Bono 2 me cambiaron la vida. Cuando tengo una semana difícil, abro una ficha y la clase funciona sola. Sin preparación extra. Sin estrés. No puedo creer que esto existiera y no lo supiera antes." name="Valeria T." location="Santa Fe" level="Docente de Inglés Primaria" data-id="element-292" />
        </div>
      </div>
    </section>;
}